import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Wind, Sun, Flower } from 'lucide-react';
export function SolutionSection() {
  const herbs = [{
    name: 'Valeriana',
    effect: 'Sedación profunda',
    icon: <Leaf className="w-6 h-6" data-id="element-145" />,
    desc: 'La reina del sueño profundo.'
  }, {
    name: 'Pasiflora',
    effect: 'Reduce ansiedad',
    icon: <Flower className="w-6 h-6" data-id="element-146" />,
    desc: 'Apaga el ruido mental.'
  }, {
    name: 'Manzanilla',
    effect: 'Digestiva y calmante',
    icon: <Sun className="w-6 h-6" data-id="element-147" />,
    desc: 'Relaja el estómago nervioso.'
  }, {
    name: 'Lavanda / Tilo',
    effect: 'Aroma relajante',
    icon: <Wind className="w-6 h-6" data-id="element-148" />,
    desc: 'Baja la frecuencia cardíaca.'
  }];
  return <section className="py-14 md:py-24 px-4 bg-forest-800 relative overflow-hidden" data-id="element-149">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-forest-600 rounded-full blur-[120px] opacity-20 translate-x-1/2 -translate-y-1/2" data-id="element-150" />

      <div className="max-w-6xl mx-auto" data-id="element-151">
        <div className="text-center mb-10 md:mb-16" data-id="element-152">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} className="text-gold-400 uppercase tracking-widest text-sm font-bold mb-2 block" data-id="element-153">
            La Solución Natural
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-6xl font-serif font-bold text-gold-500 mb-4 md:mb-6" data-id="element-154">
            El Ciclo de Sueño del <br data-id="element-155" />
            Mercado Sonora
          </motion.h2>
          <p className="text-lg md:text-xl text-cream-200 max-w-2xl mx-auto" data-id="element-156">
            Rotación de 4 tés de plantas frescas de los mercados Sonora (CDMX) o
            Corabastos (Bogotá).
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-157">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-158">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-2 border-gold-500/20" data-id="element-159">
              <img src="https://cdn.magicpatterns.com/uploads/9eXtYrThtAbg3WLQnPVgKE/mockup-2.png" alt="Guía en tablet con taza de té" className="w-full h-auto object-cover" data-id="element-160" />
            </div>
            {/* Stats Overlay */}
            <div className="absolute -bottom-6 -right-6 bg-forest-700 p-6 rounded-xl border border-gold-500 shadow-xl max-w-xs hidden md:block" data-id="element-161">
              <p className="text-gold-400 font-bold text-lg mb-1" data-id="element-162">
                Resultados Reales
              </p>
              <p className="text-cream-300 text-sm" data-id="element-163">
                "Sube GABA natural 3x vs pastillas. Rota para evitar
                tolerancia."
              </p>
            </div>
          </motion.div>

          {/* Grid Side */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-164">
            {herbs.map((herb, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-forest-700/50 border border-forest-500 hover:border-gold-500/50 p-4 md:p-6 rounded-xl transition-colors group" data-id="element-165">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-forest-800 rounded-full flex items-center justify-center text-gold-500 mb-3 md:mb-4 group-hover:scale-110 transition-transform border border-forest-600" data-id="element-166">
                  {herb.icon}
                </div>
                <h3 className="text-xl font-serif font-bold text-cream-100 mb-1" data-id="element-167">
                  {herb.name}
                </h3>
                <p className="text-gold-400 font-medium text-sm mb-2" data-id="element-168">
                  {herb.effect}
                </p>
                <p className="text-cream-300 text-sm" data-id="element-169">{herb.desc}</p>
              </motion.div>)}

            <div className="sm:col-span-2 mt-4 md:mt-6 bg-gold-500/10 border border-gold-500/30 rounded-lg p-3 md:p-4 text-center" data-id="element-170">
              <p className="text-gold-400 font-medium" data-id="element-171">
                💰 Costo promedio:{' '}
                <span className="font-bold text-cream-100" data-id="element-172">
                  50 pesos / semana
                </span>{' '}
                en plantas frescas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}